import React from 'react';
import { Tooltip, Box } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { StyledButton, ProjectTitle, AddressbookLabelText } from './styles';

const AddressbookLabel = props => {
  const {
    addressbookLabel,
    tooltip = 'Address book actions',
    projectTitle,
    className = '',
    ...restProps
  } = props;

  return (
    <Tooltip title={tooltip}>
      <StyledButton className={className} {...restProps}>
        <Box>
          <AddressbookLabelText>
            {addressbookLabel?.length > 55 ? `${addressbookLabel.substring(0, 55)}...` : addressbookLabel}
          </AddressbookLabelText>
          <br />
          <ProjectTitle>
            Project:&nbsp;
            {projectTitle?.length > 55 ? `${projectTitle.substring(0, 55)}...` : projectTitle}
          </ProjectTitle>
        </Box>
        <ArrowDropDownIcon />
      </StyledButton>
    </Tooltip>
  );
};

export default AddressbookLabel;
